import * as ReactDOM from 'react-dom/client';
import 'moment/dist/locale/pt-br';

import './tailwind.css';
import Dashboard from './Dashboard';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<Dashboard />);
